/**
 * Configuration file for the CPVC API
 * TODO: Change the username and password to the correct ones
 * @type {{url: string, username: string, password: string}}
 * @since 0.1.0
 * @version 0.1.0
 * @date 2021-06-07
 * @category Configuration
 */

const config = {
    url: "https://qua-irn.justica.gov.pt/CPVC_IntegratedService_Wordpress/rest",
    username: "DecisaoFinalUser",
    password: "LM49#B3m321",
};

export default config;